interface IHomepageCard {
  title: string;
  image: string;
  description: string;
  url: string;
}

export const HomepageCard = ({
  title,
  image,
  description,
  url,
}: IHomepageCard) => {
  return (
    <div className="card w-96 bg-base-100 shadow-xl">
      <figure>
        <img src={image} alt="Ask Stats" />
      </figure>
      <div className="card-body">
        <h2 className="card-title">{title}</h2>
        <p>{description}</p>
        <div className="card-actions pt-3">
          <a href={url}>
            <div className="btn btn-primary">Go!</div>
          </a>
        </div>
      </div>
    </div>
  );
};
